import React from 'react';
import { Box, Typography, Link, Card, CardContent, Stack } from '@mui/material';
import { ANNUAL_REPORT_TECHNICAL_ASSISTANCE_FORM_URL } from '../../constants/annualReports';

interface ResourceItem {
  href: string;
  label: string;
  description?: string;
}

const ANNUAL_REPORT_RESOURCES: ResourceItem[] = [
  {
    href: ANNUAL_REPORT_TECHNICAL_ASSISTANCE_FORM_URL,
    label: 'Annual Report Technical Assistance Request Form',
    description:
      'Submit a request for help with the annual reporting system or forms.',
  },
  {
    href: '/library/document/18d1780ca21949648a331cf783860be8/latest',
    label:
      'P.E.O. Annual Reports Instructions for State/Provincial/District (S/P/D) Officers',
  },
  {
    href: '/library/document/0b5b79e402b74337a0811d09974e6527/latest',
    label:
      'Annual Reports Instructions - IRS-LC for U.S. Local Chapter Treasurers',
  },
  {
    href: '/library/document/df2431c04808435f9e5daa1af180a7eb/latest',
    label:
      'Annual Reports Instructions - Roster and Dues for Local Chapter Officers',
  },
  {
    href: '/library/document/387eefc3bb6e4ad8b3bf7d85a2b3f514/latest',
    label: 'IRS-LC Worksheet',
    description:
      "Use this worksheet to collect the data that will be entered into your local chapter's online IRS-LC Form. Information may be entered online starting March 1. The completed online form must be approved by your chapter president by March 10.",
  },
  {
    href: '/library/document/2979c45ea55b4cdfaca411d343575bf8/latest',
    label:
      'State/Provincial/District Timeline for Annual Reports, Dues and Donations',
  },
  {
    href: '/library/document/d97f90275d214925b1b33e911238e174/latest',
    label:
      'Requirements for Release of State/Provincial/District Chapter Annual Reports',
  },
  {
    href: '/library/document/ff6c1c79078c44f0a452cba6335158bf/latest',
    label: 'Annual Report Tips',
  },
  {
    href: '/library/document/02ed99484e27448abd247d0db368bdcd/latest',
    label: 'Annual Report Responsibility Reassignment Form',
  },
  {
    href: '/library/document/a306073dc8c14705a773a915c1de8dd2/latest',
    label: 'Annual Report Release Template',
  },
  {
    href: '/library/document/8a19dbe3632441898834879fbbd6c56b/latest',
    label: 'IRS-SC/PC Instructions - IRS-SC/PC Form',
  },
];

const Resources: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Annual Reports Resources
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Links and forms to help with the annual reporting process.
      </Typography>

      <Card sx={{ maxWidth: 640 }}>
        <CardContent>
          <Stack spacing={2}>
            {ANNUAL_REPORT_RESOURCES.map((resource) => (
              <Box key={resource.href}>
                <Link
                  href={resource.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body1"
                >
                  {resource.label}
                </Link>
                {resource.description && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.5 }}
                  >
                    {resource.description}
                  </Typography>
                )}
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Resources;
